import { render, staticRenderFns } from "./item.vue?vue&type=template&id=61cd2143&scoped=true&"
import script from "./item.vue?vue&type=script&lang=js&"
export * from "./item.vue?vue&type=script&lang=js&"
import style0 from "./item.vue?vue&type=style&index=0&id=61cd2143&prod&lang=less&scoped=true&"
import style1 from "./item.vue?vue&type=style&index=1&id=61cd2143&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../yiweb/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61cd2143",
  null
  
)

export default component.exports